import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { notification } from 'antd';

const initialState = {
  isLoading: false,
  isError: null,
  errors: [],
  isSuccess: false,
  message: '',
  campaign: {},
};

export const updateCampaign = createAsyncThunk(
  'campaign/update-campaign',
  async ({ id, data, onSuccess, onError }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/campaign/update-campaign/${id}`, data);
      response?.data?.message && notification.success({ message: 'Success', description: response?.data?.message });
      onSuccess && onSuccess();
      return response?.data;
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.errors[0]?.message || 'Network error',
      });
      onError && onError();
      return rejectWithValue(error?.response);
    }
  }
);

const updateCampaignSlice = createSlice({
  name: 'Update Campaign',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateCampaign.pending, (state) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isError = false;
    });
    builder.addCase(updateCampaign.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.errors = [];
      state.isSuccess = action?.payload?.success;
      state.message = action?.payload?.message;
      state.campaign = action?.payload?.campaign;
    });
    builder.addCase(updateCampaign.rejected, (state, action) => {
      state.isLoading = false;
      state.campaign = {};
      state.errors = action.payload?.errors || [];
      state.isError = true;
    });
  },
});

export default updateCampaignSlice?.reducer;
